import { useThemeStore } from '@/stores/themeStore'

/** Subtle moving mist/fog overlay. Disabled under reduced-motion. */
export function MistLayer() {
  const reducedMotion = useThemeStore((s) => s.reducedMotion)
  if (reducedMotion) return null
  return <div aria-hidden className="pointer-events-none fixed inset-0 z-0 mist-layer" />
}
